const baseSettingsApiUrls = "/api/Settings";

export const SettingsApiUrls = {
  LeadTypes: `${baseSettingsApiUrls}/lead-types`,
  ActivateLeadType: (id) => `${baseSettingsApiUrls}/lead-types/${id}/activate`,
  DeactivateLeadType: (id) =>
    `${baseSettingsApiUrls}/lead-types/${id}/deactivate`,
  Users: `${baseSettingsApiUrls}/users`,
};
